import { useEffect, useState, useRef } from "react";
import { FaCheck, FaTimes } from "react-icons/fa";
import PageDiv from "../../PageDiv";
import Error from "../../alerts/Error";
import Success from "../../alerts/Success";
import Spinner from "../../Spinner";
import SmallSpinner from "../../SmallSpinner";
import AddUser from "./AddUser";

function UsersPage() {
    const [loadingUsers, setLoadingUsers] = useState(false);
    const [users, setUsers] = useState([]);
    const [error, setError] = useState("");
    const tableRef = useRef(null);
    const [tableTop, setTableTop] = useState(0);

    useEffect(() => {
        if (tableRef.current) {
        setTableTop(tableRef.current.getBoundingClientRect().top);
        }
    }, []);

    async function getUsers() {
        setLoadingUsers(true);
        const response = await fetch(`${process.env.REACT_APP_endPoint}/users`, {
            method: "GET",
            credentials: "include"
        });
        const jsonResponse = await response.json();
        if (response.status === 200) {
            setUsers(jsonResponse.map(user => { return {
                ...user,
                isChanging: false,
                successfullyChanged: null
            }}));
        }
        else {
            setError("Failed to fetch users");
        }
        setLoadingUsers(false);
    }

    useEffect(() => {
        getUsers();
    }, []);

    async function saveUser(user) {
        setUsers(prev => prev.map(element => {
            if (element.id === user.id) {
                return {
                    ...element,
                    isChanging: true,
                    successfullyChanged: null
                }
            }
            return element;
        }));

        const response = await fetch(`${process.env.REACT_APP_endPoint}/users/changeRights`, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(user)
        });

        if (response.status !== 200) {
            setUsers(prev => prev.map(element => {
                if (element.id === user.id) {
                    return {
                        ...element,
                        isChanging: false,
                        successfullyChanged: false
                    }
                }
                return element;
            }));
        }
        else {
            const userJson = await response.json();
            setUsers(prev => prev.map(element => {
                if (element.id === user.id) {
                    return {
                        ...userJson,
                        rights: element.rights,
                        isChanging: false,
                        successfullyChanged: true
                    }
                }
                return element;
            }));
        }
    }

    return (
        <PageDiv>
            { error && <Error message={error} /> }
            <AddUser getUsers={getUsers} />
            <div ref={tableRef} className="table-responsive" style={{ maxHeight: `calc(100vh - ${tableTop}px)`, overflowY: 'scroll' }}>
                { loadingUsers ? <Spinner /> :
                <table className="table table-bordered table-hover align-middle">
                    <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 0 }}>
                    <tr>
                        <th>First name</th>
                        <th>Last name</th>
                        <th>Email</th>
                        <th className="text-center">Admin</th>
                        <th className="text-center">Manager</th>
                        <th className="text-center">Accountant</th>
                        <th className="text-center">PM</th>
                        <th className="text-center">QA</th>
                        <th className="text-center">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {users.map((user) => (
                        <tr key={user.id}>
                            <td>{user.firstName}</td>
                            <td>{user.lastName}</td>
                            <td>{user.email}</td>
                            {["admin", "manager", "accountant", "pm", "qa"].map((right) => (
                                <td key={`right-${right}`} className="text-center" style={{width: "100px", minWidth: "100px", maxWidth: "100px"}}>
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={user.rights.includes(right)}
                                        onChange={(evt) => {
                                            const checked = evt.target.checked;
                                            if (checked) {
                                                setUsers(prev => prev.map(element => {
                                                    if (element.id === user.id) {
                                                        element.rights.push(right);
                                                    }
                                                    return element;
                                                }))
                                            }
                                            else {
                                                setUsers(prev => prev.map(element => {
                                                    if (element.id === user.id) {
                                                        element.rights = element.rights.filter(item => item !== right);
                                                    }
                                                    return element;
                                                }))
                                            }
                                        }}
                                    />
                                </td>
                            ))}
                            <td className="text-center" style={{width: "100px", minWidth: "100px", maxWidth: "100px"}}>
                                { user.isChanging ? <SmallSpinner /> : <>
                                    <button
                                        className="btn btn-sm btn-warning"
                                        onClick={() => saveUser(user)}
                                    >
                                        Save
                                    </button>
                                    { user.successfullyChanged === true && <FaCheck /> }
                                    { user.successfullyChanged === false && <FaTimes /> }
                                    </>
                                }
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                }
            </div>
        </PageDiv>
    );
}

export default UsersPage;
